import React from 'react';
import { Link } from "react-router-dom";
import TrendersLogo from '../assets/images/logo.png';
import PierOfCloudTechLogo from '../assets/images/logo3.png';
import { FiChevronDown, FiChevronUp, FiAlignJustify, FiX } from "react-icons/fi";
import { useState, useRef, useEffect } from "react";


import Company from './Menu/Company';
import Products from './Menu/Products';
import Services from './Menu/Services';



export default function MainHeader() {


const [showNavbar, setShowNavbar] = useState(false);
  

const [isMenuCompany, setIsMenuCompany] = useState(false);
const [isMenuProducts, setIsMenuProducts] = useState(false);
const [isMenuServices, setIsMenuServices] = useState(false);


    // Add and Remove Class on scroll
    const [scrolltopdata, setscrolltopdata] = useState('');

    useEffect(() => {
      window.addEventListener('scroll', () => {
          if (window.scrollY < 600) {
              setscrolltopdata('');
          } else {
              setscrolltopdata('scrolled');
          }
      });
  }, [])

  
//useRef API to handle outside click
const navRef = useRef(null);

  const comRef = useRef(null);
  const proRef = useRef(null);
  const proSer = useRef(null);

  useEffect(() => {
      //handle outside click using addEventListener
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    //ends
  
  
    }, []);

    const getCompanyLogo = () => {
      if (window.location.hostname === 'techtrenders.net' || window.location.hostname === 'www.techtrenders.net') {
        return TrendersLogo;
      } else {
        return PierOfCloudTechLogo;
      }
    }

    const handleClickOutside = event => {

      if (comRef.current && !comRef.current.contains(event.target)) {
        setIsMenuCompany(false)
      }

      if (proRef.current && !proRef.current.contains(event.target)) {
        setIsMenuProducts(false)
      }

      if (proSer.current && !proSer.current.contains(event.target)) {
        setIsMenuServices(false)
      }

  }
  
  const showNavMobile = () => {
    navRef.current.classList.toggle("showMenuinMobile");
  }



  useEffect(() => {
    document.body.classList.toggle('overlay_body', showNavbar);
  },[showNavbar])

  return (
    

    <div className={`main_header ${scrolltopdata}`}>
    {/* <div className="main_header"> */}
    <div className='container'>

<div className='row align-items-center'>


        <div className='col-12 d-flex align-items-center'>

        <Link to="/" className='me-3'> <img className='logo mw-100' src={getCompanyLogo()} alt=''></img></Link>

        <button 
        className='menu_bar ms-auto'
        onClick={showNavMobile} >     
        <span onClick={() => setShowNavbar(!showNavbar)}> {showNavbar ?<FiX/>:<FiAlignJustify/>}</span>      
        </button>


                <div ref={navRef} className='navbar_collapse'>
                    <ul className='navbar_ul'>

                        <li className='nav_item'> <Link to="/">Home</Link> </li>
                      
                        <li className='nav_item' ref={comRef}> <Link  onClick={() => setIsMenuCompany(!isMenuCompany)} to="">
                        Company{ isMenuCompany ?<FiChevronUp />:<FiChevronDown/> }                       
                       </Link>
                        { isMenuCompany ? <Company /> : null }
                         </li>
                         
                         <li className='nav_item' ref={proRef}> <Link  onClick={() => setIsMenuProducts(!isMenuProducts)} to="">
                         Products{ isMenuProducts ?<FiChevronUp/>:<FiChevronDown/> }                       
                       </Link>
                        { isMenuProducts ? <Products /> : null }
                         </li>     
            
                         <li className='nav_item' ref={proSer}> <Link  onClick={() => setIsMenuServices(!isMenuServices)} to="">
                         Services{ isMenuServices ?<FiChevronUp/>:<FiChevronDown/> }                       
                       </Link>
                        { isMenuServices ? <Services /> : null }
                         </li>          
                       
                        <li className='nav_item'> <Link to="/bright-ideas">Bright Ideas</Link> </li>
                        <li className='nav_item'> <Link to="/careers">Careers</Link> </li>
                        <li className='nav_item'> <Link to="/contact">Contact</Link> </li>


                    </ul>


                </div>



        </div>

        </div>

    </div>

    </div>


  )
}
